module.exports = __webpack_public_path__ + "static/emily-sansano-ea4009e09dd7d02ffe0ac2d29628bdc2.jpg";